var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57137 3C3.42541 3 3.27746 3.05668 3.16638 3.16774C2.94454 3.38952 2.94454 3.75574 3.16638 3.97736L7.19002 8L3.16638 12.0226C2.94454 12.2444 2.94454 12.6106 3.16638 12.8323C3.27382 12.9397 3.42392 13 3.57137 13C3.71882 13 3.86875 12.9398 3.97636 12.8323L8 8.80978L12.0236 12.8323C12.1311 12.9397 12.2812 13 12.4286 13C12.5736 13 12.7191 12.9468 12.8336 12.8323C13.0555 12.6105 13.0555 12.2443 12.8336 12.0226L8.81015 8L12.8336 3.97736C13.0555 3.75558 13.0555 3.38936 12.8336 3.16774C12.6118 2.94612 12.2455 2.94596 12.0238 3.16774L8.00016 7.19038L3.97653 3.16774C3.86561 3.05685 3.71766 3 3.57153 3H3.57137Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.34b4112d68c7614fd23512c43c64edbf.svg";
export { ForwardRef as ReactComponent };